import gql from 'graphql-tag';

export const DeleteDispatchSummaryMarket = gql`
  mutation DeleteDispatchSummaryMarketBulk($input: DeleteDispatchSummaryMarketBulkInput!) {
    deleteDispatchSummaryMarketBulk(input: $input) {
      deleted
    }
  }
`;
